var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.parts_list_name,
          expression: "parts_list_name"
        }
      ],
      domProps: { value: _vm.parts_list_name },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.parts_list_name = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selected_parts_list_name,
            expression: "selected_parts_list_name"
          }
        ],
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.selected_parts_list_name = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          }
        }
      },
      _vm._l(_vm.all_parts_lists, function(parts_list) {
        return _c("option", { key: _vm.parts_list_save_name(parts_list) }, [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.parts_list_save_name(parts_list)) + "\n\t\t"
          )
        ])
      })
    ),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "button", value: "Delete saved parts" },
      on: { click: _vm.parts_lists_delete_selected }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "button", value: "Load saved parts" },
      on: { click: _vm.parts_lists_load_selected }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "button", value: "Save current parts" },
      on: { click: _vm.parts_lists_save_current }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "button", value: "Refresh" },
      on: { click: _vm.parts_lists_load_from_local_storage }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "button", value: "Save to file" },
      on: { click: _vm.parts_lists_save_file }
    }),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "button", value: "Load from file" },
      on: {
        click: function($event) {
          _vm.$refs.load_file_input.click()
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      ref: "load_file_input",
      staticStyle: { display: "none" },
      attrs: { type: "file", value: "Load file" },
      on: { change: _vm.parts_lists_load_file }
    }),
    _vm._v(" "),
    _c("a", { ref: "save_file_a", staticStyle: { display: "none" } }),
    _vm._v(" "),
    _c(
      "span",
      {
        ref: "status_message",
        staticClass: "design-import-export-status-message",
        on: {
          animationend: function($event) {
            _vm.clear_status_message()
          }
        }
      },
      [_vm._v(_vm._s(_vm.status_message))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1a72554", { render: render, staticRenderFns: staticRenderFns })
  }
}